import { ProgProdCardList } from '@/md/entities/progProd/ProgProdCardList';

// Only rendered for the AES org - see aesMd.routes.jsx / AesProgDetail.jsx
// Tier-based programs carry their pricing on the Tiers, so the product card omits calc type / basis / value
export const AesProgProdList = ({ progObj, canEdit }) => {
  const isPayment = progObj?.progType === 'PERF' || progObj?.progType === 'GROWTH';

  return (
    <ProgProdCardList
      progObj={progObj}
      canEdit={canEdit}
      basisLabel={isPayment ? 'Payment Basis' : 'Basis'}
      showPricing={!progObj?.tierBased}
    />
  );
};
